/* cart-upsell.js — <cart-upsell-hero>: the post-add yes/no line in the cart drawer.
   Loaded from cart-drawer.liquid on every page (empty cart included) — see the note there.
   The hero renders VISIBLE; this only hides it when the shopper has declined this session.
   "No thanks" is remembered for the browser session (sessionStorage); the drawer re-renders on
   every cart change, so each fresh <cart-upsell-hero> checks the flag when it connects. When the
   hero has been declined, the plain cover row in the strip ([data-declined-only]) is shown instead. */
(function () {
  var KEY = 'epoch-cart-upsell-declined';
  function declined() {
    try { return JSON.parse(sessionStorage.getItem(KEY) || '{}'); } catch (e) { return {}; }
  }
  function markDeclined(key) {
    try { var d = declined(); d[key] = true; sessionStorage.setItem(KEY, JSON.stringify(d)); } catch (e) { /* private mode */ }
  }
  function syncFallbackRows(root) {
    var d = declined();
    (root || document).querySelectorAll('[data-declined-only]').forEach(function (row) {
      row.hidden = !d.cover;
    });
  }
  if (!customElements.get('cart-upsell-hero')) {
    customElements.define('cart-upsell-hero', class extends HTMLElement {
      connectedCallback() {
        var key = this.dataset.key || 'cover';
        if (declined()[key]) { this.hidden = true; syncFallbackRows(); return; }
        this.hidden = false;
        var decline = this.querySelector('[data-decline]');
        if (decline) decline.addEventListener('click', function () {
          markDeclined(key);
          this.hidden = true;
          syncFallbackRows();
        }.bind(this));
      }
    });
  }
  syncFallbackRows();
  document.addEventListener('DOMContentLoaded', function () { syncFallbackRows(); });
})();
